import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
} from "reactstrap"
import * as url from "../../../helpers/url_helper"
import {WEB_API_URL} from "../../../helpers/api_helper";
import { Link } from "react-router-dom"

//import Charts

// Pages Components
import ConfigList from "./ConfigList"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

class WerewolfConfig extends Component {
  constructor(props) {
    super(props)
    this.state = {
      game_config: []
    }

    this.togglemodal.bind(this)
    this.togglesubscribemodal.bind(this)
  }
  componentWillMount() {
    
  }
  
  componentDidMount() {
    const BToken = localStorage.getItem("gameAuth");
    const BearerToken = JSON.parse(BToken);
    fetch(`${WEB_API_URL}${url.GET_DASHBOARD_GAME_CONFIG}?game_name=Werewolf`, {
      method: 'get',
      headers: {
        'Authorization': `${BearerToken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then(data => {
      const {
        status,
        entity
      } = data ; 
  
      this.setState({ 
        game_config: [...entity]
      })
  
    }).catch(function (error) {
      console.log(error);
    });

  }

  togglemodal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }))
  }

  togglesubscribemodal = () => {
    this.setState(prevState => ({
      subscribemodal: !prevState.subscribemodal,
    }))
  }

  render() {
    const {game_config } = this.state;
    
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Web Game | AP - Werewolf Config</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.props.t("Config")}
              breadcrumbItem={this.props.t("Web Werewolf Config")}
            />

            <Row>
              <ConfigList game_config={game_config} />
            </Row>
          </Container>
        </div>        
      </React.Fragment>
    )
  }
}

WerewolfConfig.propTypes = {
  t: PropTypes.any
}

export default withTranslation()(WerewolfConfig)
